export default __webpack_public_path__ + "static/media/visaCard.230cac26.svg";